export default "__VITE_ASSET__BX5Vk1pD__"